<template>
    <div class="modal fade in" 
        tabindex="-1" 
        ref="modal" 
        role="dialog" 
        id="cardDocumentModal" 
        data-backdrop="false"
        v-show="$parent.showModalCardSelected"
        :class="{cardModalVisible : $parent.showModalCardSelected}"
        transition="expand"
        aria-hidden="true"
        aria-labelledby="cardDocumentModal"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="header__in">
                        <div class="selectors">
                            <span v-html="t.label_on" class="selected"></span>
                            <span v-html="t.label_media"></span>
                            <span v-html="t.label_urls"></span>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#FF0000"/>
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="modal-body" v-if="view">
                    <!-- modal body
                    {{$parent.modalCardSelectedInfo.name}} -->
                    <super-checkout-intern-modal-firstTab v-if="tabActive == 1" :view="view" :modalCardSelectedID="modalCardSelectedID" :haveAffiliation="isAffiliate" :idUser="idUser" :idUpline="idUpline" />
                    <super-checkout-intern-modal-secondTab v-if="tabActive == 2" />
                    <super-checkout-intern-modal-thirdTab v-if="tabActive == 3" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FirstTab from "./firstTab";
export default {
    name: "super-checkout-intern-modal",
    props: ["view", "modalCardSelectedID", "cardSelected", "isAffiliate", "idUser", "idUpline"],
    data(){
        return {
            t: this.$parent.view.translation,
            tabActive: 1
        }
    },

    mounted () {
        let body = document.querySelector('body');
        body.addEventListener('click', (event) => {
            if(event.target.children.length && event.target.children[0].classList[0] == 'modal-dialog') this.closeModal();
        })
    },

    methods: {
        closeModal() {
            let modal = document.querySelector('#cardDocumentModal');
            let body = document.querySelector('.body');

            body.appendChild(modal);
            setTimeout(() => {
                this.$parent.showModalCardSelected = false;
                this.$children[0].backgroundActive = false
                this.$children[0].showDisclosuresLink = false
            }, 100);
        },
    },

    computed: {
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .cardModalVisible {
        display: block !important;
        background: rgba(0,0,0,0.5);
    }
    #cardDocumentModal {
        overflow: auto;
    }
    .modal-dialog .modal-content {
        .modal-header {
            padding: 0 1rem;
            .header__in {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid rgba(0, 128, 252, 0.5);
                padding-bottom: 8px;
                .selectors {
                    margin-top: 1rem;
                    span {
                        font-size: .95rem;
                        color: #5B5B5B;
                        opacity: 0.5;
                        padding: 0 .5rem;
                        &.selected {
                            color: #0080FC;
                            position: relative;
                            opacity: 1;
                            &::after {
                                content: '';
                                position: absolute;
                                bottom: -9px;
                                left: 0;
                                height: 5px;
                                width: 100%;
                                background: #0080FC;
                            }
                        }
                    }
                }
                .close {
                    margin-right: -5px;
                    margin-top: 5px;
                }
            }
        }
    }
    @media (min-width: 768px) {
        .modal-dialog {
            width: 80%;
            margin: 30px auto;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/super-checkout-intern/modal/index.vue